import React from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from "react-router";

import { areAllParentEmailAddressesSet } from "state/school_money/selectors";

import Preloader from "components/school_money/Preloader";
import Guide from "components/school_money/guide/Guide";
import BasketPage from "components/school_money/basket/BasketPage";
import DinnersPage from "components/school_money/dinners/DinnersPage";
import ShopPage from "components/school_money/shop/ShopPage";
import HistoryPage from "components/school_money/history/HistoryPage";
import ClubsPage from "components/school_money/clubs/ClubsPage";
import PaymentsPage from "components/school_money/payments/PaymentsPage";
import ParentalConsentPage from "components/school_money/parental_consent/ParentalConsentPage";
import ParentEmailInputPage from "components/school_money/ParentEmailInputPage";

import "./SchoolMoneyPage.css";

class SchoolMoneyPage extends React.Component {

  render() {

    const { showParentEmailPage } = this.props;

    return (
      <div className="school_money">
        {
          showParentEmailPage ?
          <ParentEmailInputPage /> :
          <Preloader>
            <Guide />
            <Switch>
              <Redirect exact from="/school_money/" to="/school_money/dinners/" />
              <Route path="/school_money/dinners/:studentID?/:paymentID?/" component={DinnersPage} />
              <Route path="/school_money/dinners/:studentID?/" component={DinnersPage} />
              <Route path="/school_money/history/:studentID?/" component={HistoryPage} />
              <Route path="/school_money/basket/" component={BasketPage} />
              <Route path="/school_money/shop/:studentID?/" component={ShopPage} />
              <Route path="/school_money/clubs/:studentID?/:paymentID?/" component={ClubsPage} />
              <Route path="/school_money/clubs/:studentID?/" component={ClubsPage} />
              <Route path="/school_money/payments/:studentID?/:paymentID?/" component={PaymentsPage} />
              <Route path="/school_money/payments/:studentID?/" component={PaymentsPage} />
              <Route path="/school_money/parental_consent/:studentID?/" component={ParentalConsentPage} />
            </Switch>
          </Preloader>
        }
      </div>
    )

  }

}

export default connect(
  state => ({
    showParentEmailPage: !areAllParentEmailAddressesSet(state)
  })
)(SchoolMoneyPage);



// WEBPACK FOOTER //
// ./src/components/school_money/SchoolMoneyPage.js